import React, { useContext } from "react";
import { observer } from "mobx-react-lite";
import { Context } from "../../../index";
import { Pagination as BootstrapPagination } from "react-bootstrap";
import { useMediaQuery } from "react-responsive";

const Pagination = observer(() => {
  const { product } = useContext(Context);
  const pageCount = product.pageCount-1;
  const currentPage = product.page;

  const isMobile = useMediaQuery({ maxWidth: 600 });

  if (pageCount <= 1) return null;

  const handleClick = (page) => {
    if (page !== currentPage && page >= 1 && page <= pageCount) {
      product.setPage(page);
      product.setReload(product.reload + 1);
    }
  };

  const getPageItem = (page) => (
    <BootstrapPagination.Item
      key={page}
      active={page === currentPage}
      onClick={() => handleClick(page)}
    >
      {page}
    </BootstrapPagination.Item>
  );

  const renderPages = () => {
    const pages = [];

    if (isMobile) {
      // Только текущая, предыдущая и следующая
      if (currentPage > 1) pages.push(getPageItem(currentPage - 1));
      pages.push(getPageItem(currentPage));
      if (currentPage < pageCount) pages.push(getPageItem(currentPage + 1));
    } else {
      if (pageCount <= 7) {
        for (let i = 1; i <= pageCount; i++) {
          pages.push(getPageItem(i));
        }
      } else {
        pages.push(getPageItem(1));

        if (currentPage > 3) {
          pages.push(<BootstrapPagination.Ellipsis key="start-ellipsis" disabled />);
        }

        for (let i = currentPage - 1; i <= currentPage + 1; i++) {
          if (i > 1 && i < pageCount) {
            pages.push(getPageItem(i));
          }
        }

        if (currentPage < pageCount - 2) {
          pages.push(<BootstrapPagination.Ellipsis key="end-ellipsis" disabled />);
        }

        pages.push(getPageItem(pageCount));
      }
    }

    return pages;
  };

  return (
    <div className="d-flex justify-content-center mt-4">
      <BootstrapPagination size={isMobile ? "sm" : "md"}>
        <BootstrapPagination.First
          onClick={() => handleClick(1)}
          disabled={currentPage === 1}
        />
        <BootstrapPagination.Prev
          onClick={() => handleClick(currentPage - 1)}
          disabled={currentPage === 1}
        />
        {renderPages()}
        <BootstrapPagination.Next
          onClick={() => handleClick(currentPage + 1)}
          disabled={currentPage === pageCount}
        />
        <BootstrapPagination.Last
          onClick={() => handleClick(pageCount)}
          disabled={currentPage === pageCount}
        />
      </BootstrapPagination>
    </div>
  );
});

export default Pagination;
